import React from "react";
import { FlexDiv } from "../assets/styles/style";
import AllWritingComponents from "../components/Writing/AllWritingComponents";

const Writing = () => {
  return (
    <>
      <FlexDiv>
        <AllWritingComponents />
      </FlexDiv>
    </>
  );
};

export default Writing;


//Currently This page is being used to render all the cards and components during development 
